import React from 'react';
import {
  Labeled,
  BooleanField,
  FunctionField,
  TextField,
} from 'react-admin';

export default props => (
  <div
    className="row"
    style={{ display: 'flex', flexDirection: 'column' }}
  >
    <Labeled label="Disable Bank Linkage in Funnel">
      <BooleanField
        source="appConfig.bankLink.disableInFunnel"
        style={{ width: '100%' }}
        {...props}
      />
    </Labeled>
    <FunctionField
      {...props}
      label="Funnel Alert Text"
      render={innerRecord => innerRecord.appConfig &&
        innerRecord.appConfig.bankLink &&
        innerRecord.appConfig.bankLink.disableInFunnel &&
        <Labeled label="Funnel Alert Text">
          <TextField
            component="pre"
            source="appConfig.bankLink.funnelDisclaimer"
            style={{ 'white-space': 'pre-wrap' }}
            fullWidth
            multiline
            minRows={1}
            maxRows={4}
            {...props}
          />
        </Labeled>
      }
    />
    <Labeled label="Disable Bank Linkage in Mobile">
      <BooleanField
        source="appConfig.bankLink.disableInMobile"
        style={{ width: '100%' }}
        {...props}
      />
    </Labeled>
    <FunctionField
      {...props}
      label="Mobile Alert Text"
      render={innerRecord => innerRecord.appConfig &&
        innerRecord.appConfig.bankLink &&
        innerRecord.appConfig.bankLink.disableInMobile &&
        <Labeled label="Mobile Alert Text">
          <TextField
            component="pre"
            source="appConfig.bankLink.mobileDisclaimer"
            style={{ 'white-space': 'pre-wrap' }}
            fullWidth
            multiline
            minRows={1}
            maxRows={4}
            {...props}
          />
        </Labeled>
      }
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Config/BankLinkConfig_Show.jsx